import React, { useState } from "react";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Modal, Tooltip } from "@mui/material";

const ShowPatientText = ({ text, onClose }) => {
  const [open, setOpen] = useState(false);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    boxSizing: "border-box",
    width: "550px",
    background: "white",
    outline: "none",
    borderRadius: 10,
    fontSize: 14,
    textAlign: "center",
  };
  return (
    <Modal onClose={onClose} open={true}>
      <div style={modalStyle}>
        <h4>Text</h4>
        <div style={{ userSelect: "text", fontSize: 16, textAlign: "left" }}>
          {text}
          <Tooltip
            onClose={() => setOpen(false)}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title="Copied"
          >
            <FileCopyIcon
              fontSize="small"
              id="copyBtn"
              onClick={() => {
                setOpen(true);
                navigator.clipboard.writeText(text);
              }}
              color="secondary"
              style={{ cursor: "pointer", marginLeft: 10 }}
            />
          </Tooltip>
        </div>
      </div>
    </Modal>
  );
};

export default ShowPatientText;
